<app-document
  *ngIf="leadSeq"
  [entitySeq]="leadSeq"
  [moduleSeq]="LEADS_MODULE_SEQ">
</app-document>

<!-- CONTINUE -->
<div
  *ngIf="leadSeq"
  class="flex gap-3 mt-6"
>

  <button
    (click)="goNext()"
    class="bg-indigo-600 text-white px-6 py-2 rounded-lg font-semibold"
  >
    {{ 'COMMON.CONTINUE' | translate }}
  </button>

</div>